import { useQuery, QueryFunction } from '@tanstack/react-query'

const URL = import.meta.env.VITE_EPC_API_URL ?? ''

/**
 * Hook to fetch companies without authentication requirement
 */
export const useCompanies = () => {
  const getCompanies: QueryFunction<string[]> = async () => {
    try {
      // Use standard fetch since this endpoint doesn't require authentication
      const response = await fetch(`${URL}/profile/companies`, {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' },
      })

      if (!response.ok) {
        throw new Error(
          `Failed to fetch companies: ${response.status} ${response.statusText}`
        )
      }

      return await response.json()
    } catch (error) {
      console.error('Error fetching companies:', error)
      // Return empty array on error
      return []
    }
  }

  return useQuery({
    queryKey: ['companies'] as const,
    queryFn: getCompanies,
    retry: 2, // Allow retries since this is a public endpoint
    staleTime: 5 * 60 * 1000, // 5 minutes
  })
}
